import { render, staticRenderFns } from "./BirthName.vue?vue&type=template&id=f0fea0f8&"
import script from "./BirthName.vue?vue&type=script&lang=js&"
export * from "./BirthName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports